export default __webpack_public_path__ + "static/media/card.12aba3ef.svg";